const COLOR_KEYS = [
  'background_color',
  'text_on_background_color',
  'primary_color',
  'text_on_primary_color',
  'border_color',
];

interface Props {
  incomingKey: string;
  previousValue: string;
  newValue: string;
}

const isHexCodeWithOpacity = (value: string): boolean => {
  return /^#[0-9a-fA-F]{8}$/.test(value);
};

const isValidHexColor = (value: string): boolean => {
  return /^#[0-9a-fA-F]{6}$/.test(value) || /^#[0-9a-fA-F]{8}$/.test(value);
};

export function handleOpacityApplication({ incomingKey, previousValue, newValue }: Props): string {
  if (COLOR_KEYS.includes(incomingKey) && isHexCodeWithOpacity(previousValue)) {
    const opacityChars = previousValue.slice(7, 9);

    // Only append opacity if the new value doesn't already have opacity
    if (!isHexCodeWithOpacity(newValue)) {
      const adjustNewValue = newValue + opacityChars;
      // Ensure the result is a valid hex color
      return isValidHexColor(adjustNewValue) ? adjustNewValue : newValue;
    }
  }

  return newValue;
}
